import { SITE_URL, FAVICON_URL } from "./site";

const UPDATED_DATE = "2026-08-19";

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Basetao Sheet",
  url: SITE_URL,
  logo: FAVICON_URL,
};

export const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Basetao Sheet",
  url: SITE_URL,
  description:
    "Basetao Spreadsheet guide: compare sellers, products, shipping costs, warehouse info, coupons and QC tips. Learn how to use Basetao Spreadsheet safely.",
};

export function buildArticleSchema(opts: {
  title: string;
  description: string;
  slug: string;
  image?: string;
  lang: string;
}) {
  const schema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: opts.title,
    description: opts.description,
    mainEntityOfPage: `${SITE_URL}/article/${opts.slug}`,
    author: {
      "@type": "Organization",
      name: "Basetao Sheet",
      url: SITE_URL,
    },
    publisher: {
      "@type": "Organization",
      name: "Basetao Sheet",
      url: SITE_URL,
      logo: FAVICON_URL,
    },
    inLanguage: opts.lang,
    datePublished: UPDATED_DATE,
    dateModified: UPDATED_DATE,
  };

  if (opts.image) {
    schema.image = opts.image;
  }

  return schema;
}